import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground">
      {/* Brand Strip */}
      <div className="border-b border-primary-foreground/20">
        <div className="section-container py-8">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-6 text-center">
            <div className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 bg-primary-foreground/10 rounded-full flex items-center justify-center">
                <span className="text-2xl">⭐</span>
              </div>
              <p className="text-sm">4.6★ Rating</p>
            </div>
            <div className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 bg-primary-foreground/10 rounded-full flex items-center justify-center">
                <span className="text-2xl">💬</span>
              </div>
              <p className="text-sm">WhatsApp Order</p>
            </div>
            <div className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 bg-primary-foreground/10 rounded-full flex items-center justify-center">
                <span className="text-2xl">🥗</span>
              </div>
              <p className="text-sm">Fresh Ingredients</p>
            </div>
            <div className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 bg-primary-foreground/10 rounded-full flex items-center justify-center">
                <span className="text-2xl">👨‍🍳</span>
              </div>
              <p className="text-sm">Hygienic Kitchen</p>
            </div>
            <div className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 bg-primary-foreground/10 rounded-full flex items-center justify-center">
                <span className="text-2xl">🕐</span>
              </div>
              <p className="text-sm">Open till 11:30 PM</p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="section-container py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-display font-semibold mb-4">Contact Us</h3>
            <div className="space-y-3 text-sm text-primary-foreground/80">
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                <p>Chettikulam, 578, Beach Rd, Chetti Kulam, Tamil Nadu 629002</p>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4 flex-shrink-0" />
                <a href="tel:09994520043" className="hover:text-secondary transition-colors">
                  099945 20043
                </a>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <a href="mailto:info@instacafe.com" className="hover:text-secondary transition-colors">
                  info@instacafe.com
                </a>
              </div>
            </div>
          </div>

          {/* Information */}
          <div>
            <h3 className="text-lg font-display font-semibold mb-4">Information</h3>
            <ul className="space-y-2 text-sm text-primary-foreground/80">
              <li><Link to="/" className="hover:text-secondary transition-colors">About Us</Link></li>
              <li><Link to="/" className="hover:text-secondary transition-colors">Delivery Info</Link></li>
              <li><Link to="/" className="hover:text-secondary transition-colors">Privacy Policy</Link></li>
              <li><Link to="/" className="hover:text-secondary transition-colors">Terms & Conditions</Link></li>
            </ul>
          </div>

          {/* My Account */}
          <div>
            <h3 className="text-lg font-display font-semibold mb-4">My Account</h3>
            <ul className="space-y-2 text-sm text-primary-foreground/80">
              <li><Link to="/book-seat" className="hover:text-secondary transition-colors">Book a Seat</Link></li>
              <li><Link to="/" className="hover:text-secondary transition-colors">Booking History</Link></li>
              <li><Link to="/" className="hover:text-secondary transition-colors">Wishlist</Link></li>
              <li><Link to="/" className="hover:text-secondary transition-colors">Special Offers</Link></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-lg font-display font-semibold mb-4">Newsletter</h3>
            <p className="text-sm text-primary-foreground/80 mb-4">
              Subscribe to get special offers and updates!
            </p>
            <div className="flex gap-2">
              <Input
                type="email"
                placeholder="Your email"
                className="bg-primary-foreground/10 border-primary-foreground/20 text-primary-foreground placeholder:text-primary-foreground/50"
              />
              <Button variant="secondary" size="sm">
                Subscribe
              </Button>
            </div>
            <div className="flex gap-3 mt-6">
              <a href="#" className="w-9 h-9 bg-primary-foreground/10 rounded-full flex items-center justify-center hover:bg-secondary transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 bg-primary-foreground/10 rounded-full flex items-center justify-center hover:bg-secondary transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 bg-primary-foreground/10 rounded-full flex items-center justify-center hover:bg-secondary transition-colors">
                <Twitter className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-primary-foreground/20">
        <div className="section-container py-4">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-2 text-sm text-primary-foreground/60">
            <p>© 2024 Insta Cafe. All rights reserved.</p>
            <p>Designed with ❤️ in Nagercoil</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;